import React, { useState } from "react";
import PropTypes from "prop-types";
import Modal from "../global/modal";
import ModalClose from "../global/modalClose";
import { getString, getAge } from "../../utilities";
import { validAge } from "../../config";

export default function AgeGateModal({ showAgeGateModal, setAgeGateModal, submit }) {
  const [month, setMonth] = useState("mm");
  const [day, setDay] = useState("dd");
  const [year, setYear] = useState("yyyy");

  const resetAgeGate = () => {
    setMonth("mm");
    setDay("dd");
    setYear("yyyy");
    setAgeGateModal((prev) => !prev);
  };

  const checkAge = (e) => {
    const age = getAge(year, month, day);

    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (age >= validAge && age <= 100) {
      submit();
    }
    resetAgeGate();
  };

  const renderYears = () => {
    const yearOptions = [
      <option value="yyyy" key="0" disabled>
        YYYY
      </option>,
    ];
    const currentYear = new Date().getFullYear();
    for (let y = 0; y < 120; y++) {
      const myYear = currentYear - y;
      yearOptions.push(
        <option value={myYear} key={y + 1}>
          {myYear}
        </option>,
      );
    }
    return yearOptions;
  };

  const renderDays = () => {
    const dayOptions = [
      <option value="dd" key="0" disabled>
        DD
      </option>,
    ];
    for (let d = 1; d <= 31; d++) {
      const myDay = d > 9 ? `${d}` : `0${d}`;
      dayOptions.push(
        <option value={myDay} key={d}>
          {myDay}
        </option>,
      );
    }
    return dayOptions;
  };

  const renderMonths = () => {
    const monthOptions = [
      <option value="mm" key="0" disabled>
        MM
      </option>,
    ];
    for (let m = 0; m < 12; m++) {
      monthOptions.push(
        <option value={m} key={m + 1}>
          {getString(`months.${m}`)}
        </option>,
      );
    }
    return monthOptions;
  };

  return (
    <Modal doShow={showAgeGateModal} closeOnEscape={resetAgeGate}>
      <ModalClose close={resetAgeGate} />
      <div className="modal-content-header">{getString("ageGate.title")}</div>

      <p>{getString("ageGate.message")}</p>

      <form onSubmit={checkAge}>
        <div className="birthday">
          <select
            className="birthday-months"
            data-testid="birthday-month"
            value={month}
            onChange={(e) => {
              setMonth(e.target.value);
            }}
          >
            {renderMonths()}
          </select>
          /
          <select
            value={day}
            data-testid="birthday-day"
            onChange={(e) => {
              setDay(e.target.value);
            }}
          >
            {renderDays()}
          </select>
          /
          <select
            value={year}
            data-testid="birthday-year"
            onChange={(e) => {
              setYear(e.target.value);
            }}
          >
            {renderYears()}
          </select>
        </div>

        <div>
          <button type="submit" className="button-flat-color pt-green">
            {getString("submit.1")}
          </button>
        </div>
      </form>
    </Modal>
  );
}

AgeGateModal.propTypes = {
  showAgeGateModal: PropTypes.bool.isRequired,
  setAgeGateModal: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
};
